/*@ngInject*/
const CalendarController = function ($rootScope, $scope, $controller, $timeout, coreMediator, formViewerConstant, formComponentUtil, formMediator, xmlUtil) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    let timeoutList = [];

    this.popupOpen = false;
    this.hourStep = 1;
    this.minuteStep = 1;
    this.isTimeEnabled = false;

    this.$onInit = function () {
        this.onInit();

        let uiField = this.fieldStructure.uiField;

        if (!this.fieldStructure.fieldModel) {
            this.fieldStructure.fieldModel = {
                value: ''
            };
        }

        this.isTimeEnabled = (uiField.options) ? xmlUtil.parseString(uiField.options).enableTimeEntry : false;

        this.selectedDate = this.fieldStructure.fieldModel ? formComponentUtil.parseDateFromServer(this.fieldStructure.fieldModel.value, this.isTimeEnabled) : undefined;
        this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);

        this.fieldStructure.hasLocalChanges = false;
        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    };

    this.$onChanges = function () {
        this.selectedDate = this.fieldStructure.fieldModel ? formComponentUtil.parseDateFromServer(this.fieldStructure.fieldModel.value, this.isTimeEnabled) : undefined;
        this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
        this.onChanges();
    };

    this.handleChange = function (event) {
        if(event && event.target) {
            let targetElement = $(event.target),
                isDaySelected = targetElement.parents('.uib-day').length > 0;

            if (isDaySelected) {
                this.fieldStructure.hasLocalChanges = true;
                formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);

                this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
                this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
                this.updateFieldValue();

                if (!this.isTimeEnabled) {
                    this.popupOpen = false;
                }
            }
        }
    };

    this.handleClose = function () {
        const selected = this.selectedDate;

        if (selected) {
            const modified = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
            if (modified !== this.fieldStructure.fieldModel.value) {
                this.fieldStructure.hasLocalChanges = true;
                this.fieldStructure.fieldModel.value = modified;
                this.updateFieldValue();
            }
        }
    }

    this.handleKeyup = function (event) {
        let isDayModeSelected = (event) ? $(event.target).hasClass('uib-daypicker') : false;

        if (event.which === 13 && isDayModeSelected) {
            this.fieldStructure.hasLocalChanges = true;
            formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);

            this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
            this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
            this.updateFieldValue();
        }
    };

    this.handleBlur = function () {
        let date,
            isSameAsOriginal = this.textInputDate === formComponentUtil.formatDateWithDefaultPreferences(this.origFieldValue, this.isTimeEnabled);

        if (this.textInputDate === '' && !isSameAsOriginal) {
            this.fieldStructure.hasLocalChanges = true;
            this.selectedDate = undefined;
            this.fieldStructure.fieldModel.value = '';
            this.updateFieldValue();
        } else {
            date = formComponentUtil.dateFromInput(this.textInputDate, this.isTimeEnabled);

            if (!_.isUndefined(date) && !isSameAsOriginal) {
                this.fieldStructure.hasLocalChanges = true;
                this.selectedDate = date;
                this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
                this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
                this.updateFieldValue();
            } else {
                // Revert back to previous date if there was a problem parsing
                this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.origFieldValue, this.isTimeEnabled);
            }
        }
    };

    this.resetFieldValue = function () {
        this.fieldStructure.fieldModel.value = this.origFieldValue;
        this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.origFieldValue, this.isTimeEnabled);
        this.selectedDate = formComponentUtil.dateFromInput(this.textInputDate, this.isTimeEnabled);
    };

    this.resetMonthView = function () {
        if (_.isUndefined(this.textInputDate) || this.textInputDate === '') {
            this.selectedDate = undefined;
        } else {
            this.selectedDate = formComponentUtil.dateFromInput(this.textInputDate, this.isTimeEnabled);
        }
    };

    this.isToday = function (date, mode) {
        let today = new Date(),
            year = today.getFullYear();
        today.setHours(12, 0, 0, 0);
        if (today.toDateString() === date.toDateString() || (mode === 'year' && year === date.getFullYear())) {
            return 'today';
        }
    };

    this.onToggleCalendarPopup = function () {
        this.popupOpen = !this.popupOpen;
    };

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umFormViewer')
    .controller('calendarController', CalendarController);
